import { CountryEntry } from './CountryEntry';

export const countriesEn: CountryEntry[] = [
  {
    name: 'Belgium',
    code: 'BE'
  },
  {
    name: 'Bulgaria',
    code: 'BG'
  },
  {
    name: 'Germany',
    code: 'DE'
  },
  {
    name: 'Denmark',
    code: 'DK'
  },
  {
    name: 'Estonia',
    code: 'EE'
  },
  {
    name: 'Finland',
    code: 'FI'
  },
  {
    name: 'France',
    code: 'FR'
  },
  {
    name: 'Greece',
    code: 'GR'
  },
  {
    name: 'Ireland',
    code: 'IE'
  },
  {
    name: 'Iceland',
    code: 'IS'
  },
  {
    name: 'Italy',
    code: 'IT'
  },
  {
    name: 'Croatia',
    code: 'HR'
  },
  {
    name: 'Latvia',
    code: 'LV'
  },
  {
    name: 'Liechtenstein',
    code: 'LI'
  },
  {
    name: 'Lithuania',
    code: 'LT'
  },
  {
    name: 'Luxembourg',
    code: 'LU'
  },
  {
    name: 'Malta',
    code: 'MT'
  },
  {
    name: 'Netherlands',
    code: 'NL'
  },
  {
    name: 'Norway',
    code: 'NO'
  },
  {
    name: 'Poland',
    code: 'PL'
  },
  {
    name: 'Portugal',
    code: 'PT'
  },
  {
    name: 'Romania',
    code: 'RO'
  },
  {
    name: 'Sweden',
    code: 'SE'
  },
  {
    name: 'Switzerland',
    code: 'CH'
  },
  {
    name: 'Slovakia',
    code: 'SK'
  },
  {
    name: 'Slovenia',
    code: 'SI'
  },
  {
    name: 'Spain',
    code: 'ES'
  },
  {
    name: 'Tschechien',
    code: 'Czechia'
  },
  {
    name: 'Hungary',
    code: 'HU'
  },
  {
    name: 'United Kingdom',
    code: 'GB'
  },
  {
    name: 'Cyprus',
    code: 'CY'
  },
  {
    name: 'Austria',
    code: 'AT'
  }
];
